import {
  TOGGLE_IS_CLOSING_VARIABLE,
  TOGGLE_MOBILE_OPEN_VARIABLE,
} from "../constants";

const INITIAL_STATE = {
  isClosing: false,
  mobileOpen: false,
};

const menuBarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_IS_CLOSING_VARIABLE:
      return {
        ...state,
        isClosing: action.payload,
      };
    case TOGGLE_MOBILE_OPEN_VARIABLE:
      return {
        ...state,
        mobileOpen: action.payload,
      };
    default:
      return state;
  }
};

export default menuBarReducer;
